import { CountrySource } from 'app/constants/configuration/countrySource'
import { GeneratedTripCountrySourceType } from 'app/constants/configuration/generatedTripCountrySourceType'
import { GenerateTripAccommodations } from 'app/constants/configuration/generateTripAccommodations'
import { TripHomelandAllowanceDurationSource } from 'app/constants/configuration/tripHomelandAllowanceDurationSource'
import { TripMonthType } from 'app/constants/configuration/tripMonthType'
import { TripPartGenerationMode } from 'app/constants/configuration/tripPartGenerationMode'

import { TripPartEuropeMode } from 'app/constants/configuration/tripPartEuropeMode'
import { TripSanitarityMode } from 'app/constants/configuration/tripSanitarityMode'
import { TripSanitarityCostMode } from 'app/constants/configuration/tripSanitarityCostMode'
import { BusinessTripConfigurationModel } from './types'

export const businessTripConfigurationMock: BusinessTripConfigurationModel = {
    tripAccomodationCountrySource: CountrySource.Delegation,
    tripPartType: TripPartGenerationMode.Group,
    tripPartEuropeMode: TripPartEuropeMode.Group,
    tripSanitarityMode: TripSanitarityMode.CalculateByDays,
    tripSanitarityCostMode: TripSanitarityCostMode.CountryMode,
    skipSanitarityOnAccommodationDays: false,
    tripAccommodationInvoiceGeneration: false,
    tripPartEuropeModeStartFrom: null,
    tripPartForeignCountryMode: TripPartGenerationMode.Group,
    tripNumberPattern: "BT-{yyyy}-{seq}",
    tripCurrencyTableDaysCount: 3,
    tripCurrencyTableDaysType: 1,
    tripCalculationDateDaysCount: 2,
    tripCalculationDateDaysType: 1,

    tripSetMultipleDestinationCountries: true,
    tripAddAccomodationOnlyForValidPolishNightRest: false,
    generateTripAccommodations: GenerateTripAccommodations.OnlyForValidRests,
    useExchangeRatesTableB: false,
    isBeginEndGpsOptionEnabled: true,
    showAmountsInCurrenciesSummaryOnDetailedTripDocument: true,
    showAmountToConfirmInEurForDetaildTripPrint: false,
    minimalRestForAccommodation: null,
    addAccommodationForFerryTrain: true,
    homelandAllowanceDurationSource: TripHomelandAllowanceDurationSource.AllParts,
    showConfirmedAmountsOnBusinessTrip: true,
    skipRegularRestForAccommodations: false,
    tripCalculationDateMonth: TripMonthType.FromTripEnd,
    priorityCountries: [
        {
            code: 'PL',
            name: 'Polska',
            id: '1',
            nationId: 1,
        }
    ],
    maxManualEntryOnAutoTrips: 10,
    maxNoDataOnAutoTrips: 5,
    skipManualEntrisOnAutoTrips: false,
    skipNoDataOnAutoTrips: false,
    isGeneratedTripTransit: false,
    startTripsFromDriving: true,
    minDrivingMinutesForStartOnDriving: 0,
    minDrivingMinutesForEndOnDriving: 0,
    generatedTripCountrySource: GeneratedTripCountrySourceType.FromGps
}
